export default function initMainNavigation() {
    if (document.querySelector('.main-navigation')) {
        new MainNavigation(document.querySelector('.main-navigation'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class MainNavigation {
    constructor($el) {
        this.$el = $el;
        this.$btnBurgerMenu = $el.querySelector('.js-burger-menu');
        this.$menuMobile = $el.querySelector('.js-menu-mobile');
        this.$btnCloseMenuMobile = $el.querySelector('.js-btn-close-menu-mobile');
        this.init();
    }

    init() {
        this.$btnBurgerMenu.addEventListener('click', (evt) => {
            this.toggleMenuMobile(evt);
        });

        this.$btnCloseMenuMobile.addEventListener('click', (evt) => {
            this.toggleMenuMobile(evt);
        });
    }

    toggleMenuMobile(evt) {
        evt.preventDefault();
        this.$menuMobile.classList.toggle('visible');
        document.querySelector('body').classList.toggle('noscroll');
    }
}
